import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminPageEdit from "@/pages/admin/AdminPageEdit";

export const Route = createFileRoute("/admin/pages/$id")({
  component: () => (
    <ProtectedRoute>
      <AdminPageEdit />
    </ProtectedRoute>
  ),
});
